import { render, staticRenderFns } from "./RegistrantAndEvent.vue?vue&type=template&id=b16fd69c&"
import script from "./RegistrantAndEvent.vue?vue&type=script&lang=js&"
export * from "./RegistrantAndEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports